// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"aba9bae3","88":"4914744b","290":"4fb25866","319":"1b4d1c30","487":"fdea5c7d","615":"fd80b009","722":"e719e348","784":"055e0186","789":"d6a23ccb","846":"059bed9f","857":"22877383","923":"38b265c9","944":"808d9f96"}[chunkId] + ".chunk.js";
};